import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface CloneStepPayload {
  newName: string;
}

export interface CloneStepResponse {
  id: string;
  step: string;
}

export async function cloneStep(
  projectUuid: string, 
  selectedStepId: string, 
  label: string,
  payload: CloneStepPayload,
  token: string
): Promise<CloneStepResponse> {
  const url = `${config.isometricApiUrl}/functional-graph/${projectUuid}/clone-node/${selectedStepId}/${label}`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error cloning step:", error);
    throw error;
  }
}

export const useCloneStep = (
  onSettled?: (res: CloneStepResponse | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      projectUuid: string;
      selectedStepId: string;
      label: string;
      body: CloneStepPayload;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return cloneStep(payload.projectUuid, payload.selectedStepId, payload.label, payload.body, token);
    },
    onSettled
  });
};